import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    animate: Boolean,
    animationClass: String,
    autoHide: Boolean,
    autoHideDelay: { type: Number, default: 3000 },
    fadeOutDuration: { type: Number, default: 500 }
  }

  connect() {
    this.element.style.setProperty('--animate-duration', '0.5s')

    // Auto-hide functionality
    if (this.autoHideValue) {
      this.autoHideTimeout = setTimeout(() => {
        this.close()
      }, this.autoHideDelayValue)
    }
  }

  close() {
    // Clear the auto-hide timeout if the user manually closes
    if (this.autoHideTimeout) {
      clearTimeout(this.autoHideTimeout)
    }

    // Set fadeOut duration
    this.element.style.setProperty('--animate-duration', `${this.fadeOutDurationValue}ms`)

    this.element.classList.remove('animate__fadeIn', 'animate__rubberBand')

    this.element.classList.add('animate__fadeOut')

    this.element.addEventListener('animationend', () => {
      this.element.remove()
    }, { once: true })
  }

  disconnect() {
    // Clean up timeout when controller is disconnected
    if (this.autoHideTimeout) {
      clearTimeout(this.autoHideTimeout)
    }
  }
}